import React, { useEffect, useRef } from 'react';
import logo from '../assets/logo-440.png';

const Navbar = ({ menuOpen, setMenuOpen, scrollToSection, scrolled }) => {
  const navRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuOpen && navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, [menuOpen, setMenuOpen]);

  return (
    <header>
      <nav
        ref={navRef}
        className={`navbar fixed top-0 w-full z-50 transition-all duration-300 backdrop-blur-xl border-b ${
          scrolled
            ? 'bg-primary-dark/98 shadow-lg shadow-black/25 border-primary-green-light/50'
            : 'bg-primary-dark/80 border-primary-green-light/20'
        }`}
        aria-label="Primary navigation"
      >
        <div className={`max-w-[1400px] mx-auto flex justify-between items-center px-[5%] transition-all duration-300 ${scrolled ? 'py-3' : 'py-4'}`}>
          <a
            href="#home"
            onClick={(e) => scrollToSection(e, '#home')}
            className="logo flex items-center gap-3 cursor-pointer hover:opacity-80 transition"
            aria-label="Jay Ambe Engineering home"
          >
            <img
              src={logo}
              alt="Jay Ambe Engineering precision CNC and VMC parts manufacturer logo"
              width="440"
              height="400"
              fetchpriority="high"
              className="h-10 w-auto"
            />
            <span className="text-lg sm:text-xl lg:text-2xl font-extrabold bg-gradient-to-r from-accent-gold via-[#F4D03F] to-primary-green-light bg-clip-text text-transparent">
              JAY AMBE ENGINEERING
            </span>
          </a>

        <ul id="primary-navigation" className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><a href="#home" onClick={(e) => scrollToSection(e, '#home')}>Home</a></li>
          <li><a href="#services" onClick={(e) => scrollToSection(e, '#services')}>Our Services</a></li>
          <li><a href="#machines" onClick={(e) => scrollToSection(e, '#machines')}>Our Machinery</a></li>
          <li><a href="#strengths" onClick={(e) => scrollToSection(e, '#strengths')}>Why Choose Us</a></li>
          <li><a href="#contact" onClick={(e) => scrollToSection(e, '#contact')}>Contact Us</a></li>
        </ul>

        <button
          type="button"
          className="menu-toggle md:hidden flex flex-col cursor-pointer gap-1.5 p-1 bg-transparent border-0"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-controls="primary-navigation"
          aria-expanded={menuOpen}
        >
          <span
            className={`w-6 h-0.5 bg-primary-green-light transition-all duration-300 ${
              menuOpen ? 'rotate-45 translate-y-2' : ''
            }`}
          ></span>
          <span
            className={`w-6 h-0.5 bg-primary-green-light transition-all duration-300 ${
              menuOpen ? 'opacity-0' : ''
            }`}
          ></span>
          <span
            className={`w-6 h-0.5 bg-primary-green-light transition-all duration-300 ${
              menuOpen ? '-rotate-45 -translate-y-2' : ''
            }`}
          ></span>
        </button>
      </div>
      </nav>
    </header>
  );
};

export default Navbar;
